<template>
    <div class="field" style="padding-right: 15px;">
        <button class="button is-premium is-small" @click="openBidModal(bid.lot_id)">
            <img src="/static/images/icons/placebid.png" class="place-bid-icon fontawesome-icon">
            Place Bid</button>
    </div>
</template>

<script>
    export default {
        props: ['bid'],
        data() {
            return {

            }
        },
        methods: {
            openBidModal(lotId) {
                this.$store.dispatch('changeCurrentBidAmountYen', '')
                this.$store.dispatch('changeCurrentBidAmountUsd', '')
                this.$store.dispatch('changeCurrentBidGroup', '')
                this.$store.dispatch('changeBidError', {field: 'status', value: false})
                this.$store.dispatch('changeBidError', {field: 'message', value:''})
                this.$store.dispatch('changeBidModalStatus', { status: true, lotId: lotId })
                this.$store.dispatch('fetchGroups', {date: this.bid.date})
                this.$store.dispatch('fetchGroupSettings')
                this.$store.dispatch('changeCurrentBidLotId', lotId)
                if (this.$store.getters.getGroupLoadingStatus) {
                    if (this.$store.getters.getRecommendedGroup !== null) {
                        this.$store.dispatch('changeSelectedGroup', this.$store.getters.getRecommendedGroup)
                    } else {
                        this.$store.dispatch('changeSelectedGroup', this.$store.getters.getNewGroup)
                    }
                }
                if (this.bid.bids.length > 0 === true) {
                    this.$store.dispatch('changeCurrentBidId', this.bid.bids[0].id)
                    this.$store.dispatch('changeCurrentBidStatus', this.bid.bids[0].status)
                    this.$store.dispatch('changeCurrentBidGroup', this.bid.bids[0].group)
                    this.$store.dispatch('changeSelectedGroup', this.bid.bids[0].group)
                }
            }
        }
    }

</script>

<style scoped>
    .button {
        font-weight: 700;
    }
    .button i {
        margin-right: 0.3em;
    }
</style>



// WEBPACK FOOTER //
// src/components/Card/Buttons/Lots/BidPlace.vue